import { MouseEvent } from "react";

export const cancelRedirectionLink = (e: MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    e.stopPropagation();
}